var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"fz-14 yx-text-color-regular"},[_vm._v("货盘联系人: "+_vm._s(_vm.row.contact_name))]),_c('p',{staticClass:"fz-14 yx-text-color-regular"},[_vm._v("手机号码: "+_vm._s(_vm.row.contact_mobile))]),_c('p',{staticClass:"fz-14 yx-text-color-regular"},[_vm._v("微信号: "+_vm._s(_vm.row.contact_wechat))])])
}
var staticRenderFns = []

export { render, staticRenderFns }